<template>
  <v-dialog v-model="isOpen" max-width="600px">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>기능설정(모두저장을 눌러야 적용됩니다.)</span>
        <v-btn icon size="small" variant="text" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-8">
        <!-- 모든 설정 불러오기 -->
        <div v-if="hasPreviousData" class="mb-2">
          <v-btn
            color="success"
            variant="tonal"
            block
            @click="applyAllPreviousSettings"
            :loading="loadingPreviousData"
          >
            모든 과거 설정 불러오기
          </v-btn>
        </div>
        <v-divider v-if="hasPreviousData" class="mb-2"></v-divider>

        <!-- 시간당 임금 - 일반 -->
        <div class="mb-3">
          <div class="d-flex align-center">
            <span class="item-label">시간당 임금 (일반)</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="bulkTimePay"
              placeholder="금액 입력"
              variant="outlined"
              density="compact"
              hide-details
              suffix="원"
              @input="onTimePayInput"
              @focus="onTimePayFocus"
              @blur="onTimePayBlur"
              style="max-width: 200px;"
            />
            <v-btn
              color="primary"
              variant="flat"
              @click="applyBulkTimePay"
              :disabled="!bulkTimePay || bulkTimePay === '0'"
            >
              적용
            </v-btn>
          </div>
        </div>

        <!-- 시간당 임금 - 가족 60분 -->
        <div class="mb-3">
          <div class="d-flex align-center">
            <span class="item-label">시간당 임금(가족 60분)</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="bulkTimePayFamily60"
              placeholder="금액 입력"
              variant="outlined"
              density="compact"
              hide-details
              suffix="원"
              @input="onTimePayFamily60Input"
              @focus="onTimePayFamily60Focus"
              @blur="onTimePayFamily60Blur"
              style="max-width: 200px;"
            />
            <v-btn
              color="primary"
              variant="flat"
              @click="applyBulkTimePayFamily60"
              :disabled="!bulkTimePayFamily60 || bulkTimePayFamily60 === '0'"
            >
              적용
            </v-btn>
          </div>
        </div>

        <!-- 시간당 임금 - 가족 90분 -->
        <div class="mb-3">
          <div class="d-flex align-center">
            <span class="item-label">시간당 임금(가족 90분)</span>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="bulkTimePayFamily90"
              placeholder="금액 입력"
              variant="outlined"
              density="compact"
              hide-details
              suffix="원"
              @input="onTimePayFamily90Input"
              @focus="onTimePayFamily90Focus"
              @blur="onTimePayFamily90Blur"
              style="max-width: 200px;"
            />
            <v-btn
              color="primary"
              variant="flat"
              @click="applyBulkTimePayFamily90"
              :disabled="!bulkTimePayFamily90 || bulkTimePayFamily90 === '0'"
            >
              적용
            </v-btn>
          </div>
        </div>

        <!-- 건강보험 -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">건강보험</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyBulkHealthInsurance(true)"
              >
                일괄 적용
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyBulkHealthInsurance(false)"
              >
                일괄 해제
              </v-btn>
            </div>
          </div>
        </div>

        <!-- 휴일수당 (공휴일가산 수가 대상) -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">휴일수당 (공휴일가산)</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyBulkHolidayAllowance(true)"
              >
                일괄 지급
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyBulkHolidayAllowance(false)"
              >
                일괄 미지급
              </v-btn>
            </div>
          </div>
        </div>

        <!-- 연장수당 -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">연장수당</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyBulkOvertimeAllowance(true)"
              >
                일괄 지급
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyBulkOvertimeAllowance(false)"
              >
                일괄 미지급
              </v-btn>
            </div>
          </div>
        </div>

        <!-- 퇴직금 -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">퇴직금</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyBulkRetirement(true)"
              >
                일괄 지급
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyBulkRetirement(false)"
              >
                일괄 미지급
              </v-btn>
            </div>
          </div>
        </div>

        <!-- 식대 -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">식대</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyBulkMealAllowance(true)"
              >
                일괄 지급
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyBulkMealAllowance(false)"
              >
                일괄 미지급
              </v-btn>
            </div>
          </div>
        </div>

        <!-- 장기근속수당 -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">장기근속수당</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyLongServiceAutoCalculate"
              >
                자동 계산
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyLongServiceClear"
              >
                일괄 미지급
              </v-btn>
            </div>
          </div>
        </div>

        <!-- 보수교육비 -->
        <div class="mb-4">
          <div class="d-flex align-center justify-space-between mb-2">
            <span class="item-label">보수교육비</span>
          </div>
          <div class="d-flex align-center gap-2">
            <input
              type="text"
              v-model="bosuEduPayAmount"
              @input="onBosuEduPayAmountInput"
              @focus="onBosuEduPayAmountFocus"
              @blur="onBosuEduPayAmountBlur"
              class="bulk-input"
              placeholder="금액 입력"
              maxlength="9"
              style="width: 140px; height: 32px; border: 1px solid #e0e0e0; border-radius: 6px; padding: 0 8px; font-size: 0.875rem;"
            />
            <span style="font-size: 0.813rem; color: #666;">원</span>
            <v-btn
              size="small"
              variant="flat"
              color="primary"
              @click="applyBosuEduPayBulk"
            >
              일괄 적용
            </v-btn>
            <v-btn
              size="small"
              variant="flat"
              color="grey"
              @click="applyBosuEduPayClear"
            >
              일괄 미지급
            </v-btn>
          </div>
        </div>

        <!-- 근로자의날 수당 (5월 & 2025년 이하만) -->
        <div v-if="isLaborDayMonth && isLegacyYear" class="mb-4">
          <div class="d-flex align-center justify-space-between">
            <span class="item-label">근로자의날 수당</span>
            <div class="d-flex gap-2">
              <v-btn
                size="small"
                variant="flat"
                color="primary"
                @click="applyBulkLaborDayAllowance(true)"
              >
                일괄 지급
              </v-btn>
              <v-btn
                size="small"
                variant="flat"
                color="grey"
                @click="applyBulkLaborDayAllowance(false)"
              >
                일괄 미지급
              </v-btn>
            </div>
          </div>
        </div>

        <v-divider class="my-4"></v-divider>

        <!-- 초기화 -->
        <div class="mb-2">
          <v-btn
            color="error"
            variant="tonal"
            block
            @click="resetAllSettings"
          >
            <v-icon start>mdi-refresh</v-icon>
            모든 급여 설정 초기화
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import axios from 'axios';

interface Props {
  modelValue: boolean;
  lebYm?: string;
  sisulCode?: string;
  currentData?: any[];
  isMagam?: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'apply-bulk-time-pay', value: string): void;
  (e: 'apply-bulk-time-pay-family-60', value: string): void;
  (e: 'apply-bulk-time-pay-family-90', value: string): void;
  (e: 'apply-bulk-health-insurance', value: boolean): void;
  (e: 'apply-bulk-holiday-allowance', value: boolean): void;
  (e: 'apply-bulk-overtime-allowance', value: boolean): void;
  (e: 'apply-bulk-retirement', value: boolean): void;
  (e: 'apply-bulk-meal-allowance', value: boolean): void;
  (e: 'apply-bulk-long-service-auto-calculate'): void;
  (e: 'apply-bulk-long-service-clear'): void;
  (e: 'apply-bulk-bosu-edu-pay', value: string): void;
  (e: 'apply-bulk-bosu-edu-pay-clear'): void;
  (e: 'apply-bulk-labor-day-allowance', value: boolean): void;
  (e: 'apply-all-previous-settings', value: { allData: Array<{ lebYm: string; data: any[] }>; recentData: { lebYm: string; data: any[] } }): void;
  (e: 'reset-all-settings'): void;
}

const props = withDefaults(defineProps<Props>(), {
  isMagam: false
});
const emit = defineEmits<Emits>();

// 모달 열림/닫힘 상태
const isOpen = ref(props.modelValue);

// 일괄 시간당 임금 변경
const bulkTimePay = ref('');
const bulkTimePayFamily60 = ref('');
const bulkTimePayFamily90 = ref('');

// 이전 달 데이터 로딩 상태
const loadingPreviousData = ref(false);

// 과거 데이터 존재 여부
const hasPreviousData = ref(false);

// 적용 상태 추적
const lastApplied = ref<{
  allSettings?: boolean;
  timePay?: string;
  timePayFamily60?: string;
  timePayFamily90?: string;
  healthInsurance?: boolean;
  holiday?: boolean;
  overtime?: boolean;
  retirement?: boolean;
  meal?: boolean;
  longServiceAutoCalculate?: boolean;
  longServiceClear?: boolean;
  laborDay?: boolean;
}>({});

// 5월 여부 확인
const isLaborDayMonth = computed(() => {
  if (!props.lebYm) return false;
  return props.lebYm.substring(4, 6) === '05';
});

// 2025년 이하 여부 확인 (근로자의날 특별 처리 대상)
const isLegacyYear = computed(() => {
  if (!props.lebYm) return false;
  const year = parseInt(props.lebYm.substring(0, 4));
  return year <= 2025;
});

// 과거 데이터 체크 함수
const checkPreviousData = async () => {
  if (!props.sisulCode || !props.lebYm) {
    hasPreviousData.value = false;
    return;
  }
  
  const currentYear = parseInt(props.lebYm.substring(0, 4));
  const currentMonth = parseInt(props.lebYm.substring(4, 6));
  const currentLebYm = props.lebYm;
  
  try {
    let searchMonth = currentMonth - 1;
    
    // 현재 연도 내에서만 검색 (1월부터 현재 월-1까지)
    while (searchMonth >= 1) {
      const targetLebYm = `${currentYear}${String(searchMonth).padStart(2, '0')}`;
      
      if (targetLebYm === currentLebYm) {
        searchMonth--;
        continue;
      }
      
      try {
        const response = await axios.get('/api/calc/caregiver-member-join', {
          params: {
            sisulCode: props.sisulCode,
            lebYm: targetLebYm,
          },
        });
        
        const data = response.data.data || [];
        
        if (data.length > 0) {
          hasPreviousData.value = true;
          return;
        }
      } catch (error) {
        // 에러 무시하고 계속 검색
      }
      
      searchMonth--;
    }
    
    hasPreviousData.value = false;
  } catch (error) {
    hasPreviousData.value = false;
  }
};

// 모달 닫기
const close = () => {
  emit('update:modelValue', false);
  // 입력값 초기화
  bulkTimePay.value = '';
  bulkTimePayFamily60.value = '';
  bulkTimePayFamily90.value = '';
  // 적용 상태 초기화
  lastApplied.value = {};
};

// 일괄 시간당 임금 적용 (일반)
const applyBulkTimePay = () => {
  if (!bulkTimePay.value || bulkTimePay.value === '0') return;
  
  const confirmed = confirm(`모든 일반 시간당 임금을 ${bulkTimePay.value}원으로 변경하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.timePay = bulkTimePay.value;
  emit('apply-bulk-time-pay', bulkTimePay.value);
};

// 일괄 시간당 임금 적용 (가족 60분)
const applyBulkTimePayFamily60 = () => {
  const numericValue = bulkTimePayFamily60.value.replace(/,/g, '');
  if (!numericValue || numericValue === '0') return;
  
  const confirmed = confirm(`모든 가족 60분 케어 시간당 임금을 ${bulkTimePayFamily60.value}원으로 변경하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.timePayFamily60 = bulkTimePayFamily60.value;
  emit('apply-bulk-time-pay-family-60', numericValue);
};

// 일괄 시간당 임금 적용 (가족 90분)
const applyBulkTimePayFamily90 = () => {
  if (!bulkTimePayFamily90.value || bulkTimePayFamily90.value === '0') return;
  
  const confirmed = confirm(`모든 가족 90분 케어 시간당 임금을 ${bulkTimePayFamily90.value}원으로 변경하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.timePayFamily90 = bulkTimePayFamily90.value;
  emit('apply-bulk-time-pay-family-90', bulkTimePayFamily90.value);
};

// 공통: 과거 데이터 수집 함수 (시간당 임금용 - 여러 달)
const fetchAllPreviousData = async (): Promise<Array<{ lebYm: string; data: any[] }>> => {
  if (!props.sisulCode || !props.lebYm) {
    return [];
  }
  
  const currentYear = parseInt(props.lebYm.substring(0, 4));
  const currentMonth = parseInt(props.lebYm.substring(4, 6));
  const currentLebYm = props.lebYm; // 현재 연월 저장
  
  loadingPreviousData.value = true;
  
  try {
    const allPreviousData: Array<{ lebYm: string; data: any[] }> = [];
    let searchMonth = currentMonth - 1;
    
    // 현재 연도 내에서만 과거 데이터 수집 (1월부터 현재 월-1까지)
    while (searchMonth >= 1) {
      const targetLebYm = `${currentYear}${String(searchMonth).padStart(2, '0')}`;
      
      // 현재 연월과 동일한 경우 건너뛰기 (중복 방지)
      if (targetLebYm === currentLebYm) {
        searchMonth--;
        continue;
      }
      
      try {
        const response = await axios.get('/api/calc/caregiver-member-join', {
          params: {
            sisulCode: props.sisulCode,
            lebYm: targetLebYm,
          },
        });
        
        const data = response.data.data || [];
        
        // 데이터가 존재하면 리스트에 추가 (최신순)
        if (data.length > 0) {
          allPreviousData.push({
            lebYm: targetLebYm,
            data: data
          });
        }
      } catch (error) {
        // 에러가 발생해도 계속 이전 달 검색
      }
      
      searchMonth--;
    }
    
    
    return allPreviousData;
    
  } catch (error: any) {
    console.error('데이터 조회 오류:', error);
    return [];
  } finally {
    loadingPreviousData.value = false;
  }
};

// 가장 최근 과거 데이터 가져오기 (수당 설정용 - 1개월만)
const fetchMostRecentPreviousData = async (): Promise<{ lebYm: string; data: any[] } | null> => {
  if (!props.sisulCode || !props.lebYm) {
    return null;
  }
  
  const currentYear = parseInt(props.lebYm.substring(0, 4));
  const currentMonth = parseInt(props.lebYm.substring(4, 6));
  const currentLebYm = props.lebYm; // 현재 연월 저장
  
  loadingPreviousData.value = true;
  
  try {
    let searchMonth = currentMonth - 1;
    
    // 현재 연도 내에서만 검색 (1월부터 현재 월-1까지)
    while (searchMonth >= 1) {
      const targetLebYm = `${currentYear}${String(searchMonth).padStart(2, '0')}`;
      
      // 현재 연월과 동일한 경우 건너뛰기 (중복 방지)
      if (targetLebYm === currentLebYm) {
        searchMonth--;
        continue;
      }
      
      try {
        const response = await axios.get('/api/calc/caregiver-member-join', {
          params: {
            sisulCode: props.sisulCode,
            lebYm: targetLebYm,
          },
        });
        
        const data = response.data.data || [];
        
        // 데이터가 존재하면 바로 반환
        if (data.length > 0) {
          return {
            lebYm: targetLebYm,
            data: data
          };
        }
      } catch (error) {
        // 에러가 발생해도 계속 이전 달 검색
      }
      
      searchMonth--;
    }
    
    return null;
    
  } catch (error: any) {
    console.error('데이터 조회 오류:', error);
    return null;
  } finally {
    loadingPreviousData.value = false;
  }
};

// 일괄 건강보험 적용/해제
const applyBulkHealthInsurance = (value: boolean) => {
  const action = value ? '적용' : '해제';
  const confirmed = confirm(`모든 요양보호사의 건강보험을 ${action}하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.healthInsurance = value;
  emit('apply-bulk-health-insurance', value);
};

// 일괄 휴일수당 적용 (공휴일가산 수가 서비스만 대상)
const applyBulkHolidayAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 휴일수당을 ${action}으로 설정하시겠습니까?\n(공휴일가산 수가가 있는 서비스만 대상)`);
  if (!confirmed) return;
  
  lastApplied.value.holiday = value;
  emit('apply-bulk-holiday-allowance', value);
};

// 일괄 연장수당 적용
const applyBulkOvertimeAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 연장수당을 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.overtime = value;
  emit('apply-bulk-overtime-allowance', value);
};

// 일괄 퇴직금 적용
const applyBulkRetirement = (value: boolean) => {
  const action = value ? '적립' : '미적립';
  const confirmed = confirm(`모든 요양보호사의 퇴직금을 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.retirement = value;
  emit('apply-bulk-retirement', value);
};

// 일괄 식대 적용
const applyBulkMealAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 식대를 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.meal = value;
  emit('apply-bulk-meal-allowance', value);
};

// 근속년수에 따라 장기근속수당 자동계산
const applyLongServiceAutoCalculate = () => {
  const confirmed = confirm('모든 요양보호사의 장기근속수당을 근속년수에 따라 자동으로 계산하시겠습니까?');
  if (!confirmed) return;
  
  lastApplied.value.longServiceAutoCalculate = true;
  lastApplied.value.longServiceClear = undefined;
  emit('apply-bulk-long-service-auto-calculate');
};

// 장기근속수당 모두 미지급 (0원)
const applyLongServiceClear = () => {
  const confirmed = confirm('모든 요양보호사의 장기근속수당을 미지급으로 설정하시겠습니까?');
  if (!confirmed) return;
  
  lastApplied.value.longServiceClear = true;
  lastApplied.value.longServiceAutoCalculate = undefined;
  emit('apply-bulk-long-service-clear');
};

// 보수교육비 일괄 설정 관련
const bosuEduPayAmount = ref('');

const onBosuEduPayAmountInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^\d]/g, '');
  if (value.length > 9) value = value.slice(0, 9);
  bosuEduPayAmount.value = value;
  input.value = value;
};

const onBosuEduPayAmountFocus = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const numericValue = input.value.replace(/,/g, '');
  input.value = numericValue === '0' ? '' : numericValue;
  bosuEduPayAmount.value = input.value;
};

const onBosuEduPayAmountBlur = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  const numericValue = input.value.replace(/[^\d]/g, '');
  if (numericValue) {
    const formatted = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formatted;
    bosuEduPayAmount.value = formatted;
  }
};

// 보수교육비 일괄 적용
const applyBosuEduPayBulk = () => {
  const numericValue = bosuEduPayAmount.value.replace(/[^\d]/g, '');
  if (!numericValue || parseInt(numericValue) <= 0) {
    alert('보수교육비 금액을 입력해주세요.');
    return;
  }
  const confirmed = confirm(`모든 요양보호사에게 보수교육비 ${new Intl.NumberFormat('ko-KR').format(parseInt(numericValue))}원을 일괄 적용하시겠습니까?`);
  if (!confirmed) return;
  
  emit('apply-bulk-bosu-edu-pay', numericValue);
};

// 보수교육비 모두 미지급 (0원)
const applyBosuEduPayClear = () => {
  const confirmed = confirm('모든 요양보호사의 보수교육비를 미지급으로 설정하시겠습니까?');
  if (!confirmed) return;
  
  bosuEduPayAmount.value = '';
  emit('apply-bulk-bosu-edu-pay-clear');
};

// 모든 설정 불러오기
const applyAllPreviousSettings = async () => {
  const confirmed = confirm('모든 과거 설정(시간당 임금, 휴일수당, 연장수당, 퇴직금, 식대, 장기근속수당, 국민연금, 건강보험, 고용보험)을 불러오시겠습니까?');
  if (!confirmed) return;
  
  // 시간당 임금용 여러 달 데이터
  const allData = await fetchAllPreviousData();
  // 수당/보험용 최근 1개월 데이터
  const recentData = await fetchMostRecentPreviousData();
  
  if (allData.length > 0 || recentData) {
    lastApplied.value.allSettings = true;
    
    emit('apply-all-previous-settings', { allData, recentData: recentData! });
  }
};

// 일괄 근로자의날 수당 적용
const applyBulkLaborDayAllowance = (value: boolean) => {
  const action = value ? '지급' : '미지급';
  const confirmed = confirm(`모든 요양보호사의 근로자의날 수당을 ${action}으로 설정하시겠습니까?`);
  if (!confirmed) return;
  
  lastApplied.value.laborDay = value;
  emit('apply-bulk-labor-day-allowance', value);
};

// 모든 설정 초기화
const resetAllSettings = () => {
  const confirmed = confirm('⚠️ 모든 급여 설정을 초기화하시겠습니까?\n\n- 모든 시급이 삭제됩니다.\n- 모든 체크박스가 해제됩니다.\n- 모든 수당/공제 금액이 초기화됩니다.\n\n이 작업은 되돌릴 수 없습니다.');
  if (!confirmed) return;
  
  emit('reset-all-settings');
  close();
};

// 시간당 임금 입력 포커스 이벤트 (컴마 제거)
const onTimePayFocus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  bulkTimePay.value = numericValue;
};

// 시간당 임금 입력 포커스 아웃 이벤트 (컴마 추가)
const onTimePayBlur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    bulkTimePay.value = formattedValue;
  } else {
    input.value = '';
    bulkTimePay.value = '';
  }
};

// 시간당 임금 입력 이벤트 (숫자만 허용)
const onTimePayInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  bulkTimePay.value = value;
};

// 시간당 임금(가족 60분) 입력 포커스 이벤트 (컴마 제거)
const onTimePayFamily60Focus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  bulkTimePayFamily60.value = numericValue;
};

// 시간당 임금(가족 60분) 입력 포커스 아웃 이벤트 (컴마 추가)
const onTimePayFamily60Blur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    bulkTimePayFamily60.value = formattedValue;
  } else {
    input.value = '';
    bulkTimePayFamily60.value = '';
  }
};

// 시간당 임금(가족 60분) 입력 이벤트 (숫자만 허용)
const onTimePayFamily60Input = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  bulkTimePayFamily60.value = value;
};

// 시간당 임금(가족 90분) 입력 포커스 이벤트 (컴마 제거)
const onTimePayFamily90Focus = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  const numericValue = value.replace(/,/g, '');
  input.value = numericValue;
  bulkTimePayFamily90.value = numericValue;
};

// 시간당 임금(가족 90분) 입력 포커스 아웃 이벤트 (컴마 추가)
const onTimePayFamily90Blur = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const value = input.value;
  
  const numericValue = value.replace(/[^\d]/g, '');
  
  if (numericValue) {
    const formattedValue = new Intl.NumberFormat('ko-KR').format(parseInt(numericValue));
    input.value = formattedValue;
    bulkTimePayFamily90.value = formattedValue;
  } else {
    input.value = '';
    bulkTimePayFamily90.value = '';
  }
};

// 시간당 임금(가족 90분) 입력 이벤트 (숫자만 허용)
const onTimePayFamily90Input = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value;
  
  value = value.replace(/[^\d]/g, '');
  
  if (value.length > 9) {
    value = value.slice(0, 9);
  }
  
  input.value = value;
  bulkTimePayFamily90.value = value;
};

// props 변경 감지
watch(() => props.modelValue, (newVal) => {
  isOpen.value = newVal;
});

watch(isOpen, (newVal) => {
  if (!newVal) {
    emit('update:modelValue', false);
  } else {
    // 모달이 열릴 때 과거 데이터 체크
    checkPreviousData();
  }
});

// 연월 변경 시 과거 설정 상태 초기화
watch(() => props.lebYm, () => {
  lastApplied.value = {};
  bulkTimePay.value = '';
  bulkTimePayFamily60.value = '';
  bulkTimePayFamily90.value = '';
  // 연월이 변경되면 과거 데이터 다시 체크
  if (isOpen.value) {
    checkPreviousData();
  }
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/setModal.scss';

.item-label {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  font-family: $Noto_Sans_KR;
}

.gap-2 {
  gap: 8px;
}

:deep(.v-card) {
  font-family: $Noto_Sans_KR;
}

:deep(.v-card-title) {
  font-family: $Noto_Sans_KR;
}

:deep(.v-btn) {
  font-family: $Noto_Sans_KR;
}

:deep(.v-text-field) {
  font-family: $Noto_Sans_KR;
}
</style>

